import PropTypes from 'prop-types';

export default function DeleteAccountModal({onConfirm, onCancel}) {
    function handleKeyDown(e) {
        if (e.key === 'Enter') onConfirm();
        if (e.key === 'Escape') onCancel();
    }

    return (
        <div
            className="modal-backdrop"
            onClick={onCancel}
            onKeyDown={e => e.key === 'Escape' && onCancel()}
            role="presentation"
        >
            <div
                className="modal"
                onClick={e => e.stopPropagation()}
                onKeyDown={handleKeyDown}
                role="dialog"
                aria-modal="true"
            >
                <h3 className="modal-title">Delete account</h3>
                <p className="modal-warning">This will permanently delete your account and all your checklists.</p>
                <div className="modal-actions">
                    <button className="modal-cancel" onClick={onCancel}>Cancel</button>
                    <button className="modal-confirm modal-confirm--danger" onClick={onConfirm}>Delete</button>
                </div>
            </div>
        </div>
    );
}

DeleteAccountModal.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};
